<template>
  <div>
    <div class="row">
      <Aguarde :show="httpSend"></Aguarde>
      <div class="col-md-6">
        <button type="button"
                @click="alterMarcarTodos()"
                class="btn btn-label btn-sm btn-sm mr-2 mb-2 btn-secondary"><i
            class="bx bx-check-double label-icon"></i>
          <span v-show="!marcar_todos">Marcar Todos</span>
          <span v-show="marcar_todos">Desmarcar Todos</span>
        </button>
        <button type="button"
                title="Verificar pagamentos"
                @click="verificarPagamento()"
                class="btn btn-label btn-sm btn-sm mr-2 mb-2 btn-success"><i class="bx bx-analyse label-icon"></i>
          Verificar Pagamento
        </button>
      </div>
      <div class="col-md-6 text-right">
        <button type="button"
                title="Pesquisar boletos"
                @click="listPixs()"
                class="btn btn-label btn-sm btn-sm mr-2 mb-2 btn-primary"><i class="bx bx-search label-icon"></i>
          Pesquisar
        </button>
      </div>
    </div>
    <div v-show="!pixs.length || pixs.length < 1" role="alert" aria-live="polite"
         aria-atomic="true" class="alert alert-primary text-center">
      Sem Pix
    </div>
    <div v-for="p in pixs" :key="p.pix_codigo" class="mt-3 row">
      <div class="col-md-12 mb-3 border-bottom">
        <div class="row">
          <div class="col-md-3">
            <b-form-group label="Código da DUAM">
              <h6 class="mb-0">{{ p.dam_codigo }}</h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <b-form-group label="Código do Pix">
              <h6 v-if="p.bab_data_pagamento" class="mb-0">{{ p.pix_codigo.padStart(10, "0") }}</h6>
              <b-form-checkbox
                  v-else
                  v-bind:id="'id_verificacao_pix'+p.bol_codigo"
                  v-model="p.verificar"
                  :unchecked-value="false"
                  class="custom-checkbox text-dark custom-checkbox-outline custom-checkbox-primary mb-3">
                {{ p.pix_codigo.padStart(10, "0") }}
              </b-form-checkbox>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Nome/Razão Social">
              <h6 class="mb-0">{{ p.pes_nome }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Status">
              <h6 v-if="p.send_http" class="mb-0">
                <span><i class="fas fa-sync fa-spin font-size-14 text-dark"></i> Verificando</span>
              </h6>
              <h6 v-else class="mb-0">
                <span v-show="p.pix_status === 1" class="badge badge-warning font-size-12">Aguardando Pagamento</span>
                <span v-show="p.pix_status === 5" class="badge badge-danger font-size-12">Cancelado</span>
                <span v-show="p.pix_status === 6" class="badge badge-danger font-size-12">Cancelado pelo Sistema</span>
                <span v-show="p.pix_status === 9" class="badge badge-success font-size-12">Pago</span>
              </h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <b-form-group label="Expiração">
              <h6 class="mb-0">{{ p.expiracao | formatDateHora }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Valor Total">
              <h6 class="mb-0">{{ p.pix_valor | formatNumeroBr }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Data do Pagamento">
              <h6 v-if="p.bab_data_pagamento" class="mb-0">{{ p.bab_data_pagamento | formatDate }}</h6>
              <h6 v-else class="mb-0">-</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Valor Pago">
              <h6 v-if="p.bab_valor_pago" class="mb-0">{{ p.bab_valor_pago | formatNumeroBr }}</h6>
              <h6 v-else class="mb-0">-</h6>
            </b-form-group>
          </div>
        </div>
        <div v-show="p.erro_processamento" class="row">
          <div class="col-md-12">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-dismissible alert-warning"><i
                class="mdi mdi-alert-outline mr-2"></i>{{ p.msg_erro_processamento }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p class="text-dark mb-0 font-weight-bold">Valor total: {{ valor_total | formatNumeroBr }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import Aguarde from "@/components/widgets/aguarde";
import {
  listRetornoPagamentoPix, verificaRetornoPagamentoPix
} from "@/api/admin/gestao/retorno_pagamento";

export default {
  components: {
    Aguarde
  },
  props: {
    filtro: {
      type: Object,
      require: true
    },
  },
  data() {
    return {
      httpSend: false,
      marcar_todos: true,
      pixs: []
    };
  },
  created() {
    this.listPixs()
  },
  computed: {
    valor_total: {
      get: function () {
        return this.pixs
            .map(p => Number(p.pix_valor))
            .reduce((sum, current) => sum + current, 0);
      }
    }
  },
  methods: {
    listPixs() {
      this.httpSend = true;
      listRetornoPagamentoPix(this.filtro).then(result => {
        if (result.status) {
          this.pixs = result.dados;
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    alterMarcarTodos() {
      this.marcar_todos = !this.marcar_todos;
      this.pixs.forEach(function (pix) {
        pix.verificar = this.marcar_todos;
      }, this);
    },
    verificarPagamento() {
      const pixs = this.pixs.filter((b) => b.verificar);
      if (pixs.length < 1) {
        this.$toast.error("Nenhum Pix selecionado");
        return
      }
      pixs.forEach(function (pix) {
        this.verifica(pix)
      }, this);
    },
    verifica(pix) {
      pix.send_http = true;
      verificaRetornoPagamentoPix(pix.pix_hash).then(result => {
        if (result.status) {
          pix.erro_processamento = false;
          pix.pix_status = result.dados.pix_codigo_status;
          if (result.dados.liquidado) {
            pix.bab_data_pagamento = result.dados.data_credito;
            pix.bab_valor_pago = result.dados.valor_pago;
          }
        } else {
          pix.erro_processamento = true;
          pix.msg_erro_processamento = result.mensagem;
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        pix.send_http = false;
      })
    }
  }
};
</script>
